import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import { get } from 'lodash-es';
import isString from 'lodash-es/isString';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import AvatarElement from '@panneau/element-avatar';

var styles = {"container":"panneau-display-avatar-container","name":"panneau-display-avatar-name"};

var _excluded = ["value", "placeholder", "imagePath", "namePath", "size", "withoutName", "withoutImage", "className"];
var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  imagePath: PropTypes.string,
  namePath: PropTypes.string,
  size: PropTypes.number,
  withoutName: PropTypes.bool,
  withoutImage: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  imagePath: 'image',
  namePath: 'name',
  size: null,
  withoutName: false,
  withoutImage: false,
  className: null
};
var Avatar = function Avatar(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    imagePath = _ref.imagePath,
    namePath = _ref.namePath,
    size = _ref.size,
    withoutName = _ref.withoutName,
    withoutImage = _ref.withoutImage,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var image = get(value, imagePath) || value || null;
  var name = get(value, namePath) || null;
  var _ref2 = image || {},
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$thumbnailUrl = _ref2.thumbnailUrl,
    thumbnailUrl = _ref2$thumbnailUrl === void 0 ? null : _ref2$thumbnailUrl,
    _ref2$thumbnail_url = _ref2.thumbnail_url,
    altThumbnailUrl = _ref2$thumbnail_url === void 0 ? null : _ref2$thumbnail_url;
  var defaultValue = isString(image) ? image : null;
  var imageUrl = useMemo(function () {
    return altThumbnailUrl || thumbnailUrl || url || defaultValue;
  }, [altThumbnailUrl, thumbnailUrl, url, defaultValue]);
  var showImage = imageUrl !== null && !withoutImage;
  var showName = name !== null && !withoutName;
  var empty = !showImage && !showName;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles[size], size !== null), className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, showImage ? /*#__PURE__*/React.createElement(AvatarElement, Object.assign({
    name: name,
    image: {
      url: imageUrl
    },
    size: size
  }, props)) : null, showName ? /*#__PURE__*/React.createElement("span", {
    className: classNames(['ms-2', styles.name])
  }, size === 'small' ? /*#__PURE__*/React.createElement("small", null, name) : name) : null, empty ? placeholder : null));
};
Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;

export { Avatar as default };
